export enum ImprovementsTab {
  All = "all",
  Subscriptions = "subscriptions",
  Improvements = "improvements",
}
